/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { DimensionEnum } from "./DimensionEnum";
import {
  DimensionEnumFromJSON,
  DimensionEnumFromJSONTyped,
  DimensionEnumToJSON,
  DimensionEnumToJSONTyped,
} from "./DimensionEnum";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface InitialConcentration
 */
export interface InitialConcentration {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly threedimodel?: string;
  /**
   *
   */
  userGenerated?: boolean;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  sourceRaster?: string;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly sourceRasterId?: number | null;
  /**
   *
   */
  dimension?: DimensionEnum;
}

/**
 * Check if a given object implements the InitialConcentration interface.
 */
export function instanceOfInitialConcentration(value: object): value is InitialConcentration {
  return true;
}

export function InitialConcentrationFromJSON(json: any): InitialConcentration {
  return InitialConcentrationFromJSONTyped(json, false);
}

export function InitialConcentrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InitialConcentration {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    userGenerated: json["user_generated"] == null ? undefined : json["user_generated"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    sourceRaster: json["source_raster"] == null ? undefined : json["source_raster"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    id: json["id"] == null ? undefined : json["id"],
    sourceRasterId:
      json["source_raster_id"] === undefined
        ? undefined
        : json["source_raster_id"] === null
        ? null
        : json["source_raster_id"],
    dimension: json["dimension"] == null ? undefined : DimensionEnumFromJSON(json["dimension"]),
  };
}

export function InitialConcentrationToJSON(json: any): InitialConcentration {
  return InitialConcentrationToJSONTyped(json, false);
}

export function InitialConcentrationToJSONTyped(
  value?: Omit<
    InitialConcentration,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user_generated: value["userGenerated"],
    source_raster: value["sourceRaster"],
    dimension: DimensionEnumToJSON(value["dimension"]),
  };
}
